var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import axios from "axios";
import { format } from "@permafrost-dev/pretty-format";
import { v4 } from "uuid";
import Stacktrace from "stacktrace-js";
import formatXml from "xml-formatter";
const _Client = class _Client {
  // eslint-disable-next-line no-unused-vars
  constructor(portNumber = 23517, host = "localhost", scheme = "http") {
    this.portNumber = portNumber;
    this.host = host;
    this.scheme = scheme;
  }
  async init() {
    await this.updateRayAvailability();
  }
  isRayAvailable() {
    this.attemptAvailableReset();
    if (_Client.rayState === null) {
      this.updateRayAvailability();
    }
    if (_Client.rayState !== null) {
      return _Client.rayState;
    }
    return true;
  }
  attemptAvailableReset() {
    if (_Client.lastRayStateCheck !== null && (/* @__PURE__ */ new Date()).getTime() - _Client.lastRayStateCheck >= 3e4) {
      _Client.rayState = null;
    }
  }
  async updateRayAvailability() {
    let result = true;
    if (_Client.lastRayStateCheck !== null && (/* @__PURE__ */ new Date()).getTime() - _Client.lastRayStateCheck < 3e4) {
      return true;
    }
    _Client.lastRayStateCheck = (/* @__PURE__ */ new Date()).getTime();
    try {
      await axios.get(this.getUrlForPath("/locks/__availabilty_check"), {});
    } catch (err) {
      result = false;
      if (err.response) {
        result = true;
      }
    } finally {
      _Client.rayState = result;
    }
  }
  getUrlForPath(path) {
    var _a;
    path = path.replace(/^\//, "");
    return `${(_a = this.scheme) != null ? _a : "http"}://${this.host}:${this.portNumber}/${path}`;
  }
  async send(request) {
    if (_Client.rayState === null || _Client.lastRayStateCheck === null) {
      this.updateRayAvailability();
    }
    try {
      request.payloads = this.ensureAllPayloadsHaveAnOrigin(request.payloads);
      await axios.post(this.getUrlForPath("/"), request.toArray(), { withCredentials: false });
      await new Promise((resolve) => setTimeout(resolve, 50));
    } catch (err) {
    }
  }
  ensureAllPayloadsHaveAnOrigin(payloads) {
    payloads.forEach((payload) => {
      if (payload.data.origin.file === null || payload.data.origin.file === "" || typeof payload.data.origin["file"] === "undefined") {
        payload.data.origin["file"] = "/unknown-file.js";
        payload.data.origin["line_number"] = 1;
        payload.data.origin["function_name"] = "unknown";
      }
    });
    return payloads;
  }
  async lockExists(lockName) {
    return new Promise(async (resolve, reject) => {
      let resp;
      try {
        resp = await axios.get(this.getUrlForPath(`/locks/${lockName}`));
      } catch (err) {
        return false;
      }
      if (resp.data.stop_execution) {
        reject(new Error("stopping execution"));
        return;
      }
      if (typeof resp.data["active"] === "undefined") {
        resolve(resp.data);
        return;
      }
      resolve(resp.data);
    });
  }
};
__publicField(_Client, "rayState", true);
__publicField(_Client, "lastRayStateCheck", null);
let Client = _Client;
class RayColors {
  /* istanbul ignore next */
  color(name) {
    return this;
  }
  green() {
    return this.color("green");
  }
  orange() {
    return this.color("orange");
  }
  red() {
    return this.color("red");
  }
  purple() {
    return this.color("purple");
  }
  blue() {
    return this.color("blue");
  }
  gray() {
    return this.color("gray");
  }
}
class RayScreenColors {
  screenColor(color) {
    return this;
  }
  screenGreen() {
    return this.screenColor("green");
  }
  screenOrange() {
    return this.screenColor("orange");
  }
  screenRed() {
    return this.screenColor("red");
  }
  screenPurple() {
    return this.screenColor("purple");
  }
  screenBlue() {
    return this.screenColor("blue");
  }
  screenGray() {
    return this.screenColor("gray");
  }
}
class RaySizes {
  /* istanbul ignore next */
  size(size) {
    return this;
  }
  small() {
    return this.size("sm");
  }
  large() {
    return this.size("lg");
  }
}
class RemovesRayFrames {
  static removeRayFrames(frames) {
    return frames.filter((frame) => !RemovesRayFrames.isRayFrame(frame) && !RemovesRayFrames.isNodeFrame(frame));
  }
  static isRayFrame(frame) {
    var _a;
    for (const rayNamespace of this.rayNamespaces()) {
      if ((_a = frame.fileName) == null ? void 0 : _a.includes(rayNamespace)) {
        return true;
      }
    }
    return false;
  }
  static isNodeFrame(frame) {
    var _a, _b;
    return ((_a = frame.fileName) == null ? void 0 : _a.includes("node:")) || ((_b = frame.fileName) == null ? void 0 : _b.includes("node_modules")) || false;
  }
  static rayNamespaces() {
    return ["ray-node/dist", "node-ray/dist", "vue-ray/dist", "-ray"];
  }
}
const consoleLog = console.log.bind({});
const consoleWrapper = (...args) => {
  if (typeof Ray.client !== "undefined" && Ray.client.isRayAvailable()) {
    Ray.create().then((r) => r.send(...args));
  }
  consoleLog(...args);
};
const _ConsoleInterceptor = class _ConsoleInterceptor {
  enable() {
    _ConsoleInterceptor.active = true;
    console.log = consoleWrapper;
  }
  disable() {
    _ConsoleInterceptor.active = false;
    console.log = consoleLog;
  }
  active() {
    return _ConsoleInterceptor.active;
  }
};
__publicField(_ConsoleInterceptor, "active", false);
let ConsoleInterceptor = _ConsoleInterceptor;
const _Hostname = class _Hostname {
  static get() {
    var _a;
    return (_a = _Hostname.hostname) != null ? _a : "remote";
  }
  static set(hostname) {
    _Hostname.hostname = hostname;
  }
};
__publicField(_Hostname, "hostname", null);
let Hostname = _Hostname;
class ArgumentConverter {
  static convertToPrimitive(arg) {
    if (arg === null) {
      return { value: null, isHtml: false };
    }
    if (typeof arg === "string") {
      return { value: arg, isHtml: false };
    }
    if (typeof arg === "number") {
      return { value: arg, isHtml: false };
    }
    if (typeof arg === "boolean") {
      return { value: arg, isHtml: false };
    }
    return { value: ArgumentConverter.prettyFormatForHtml(arg), isHtml: true };
  }
  static buildHtmlElement(tagName, classes, slot) {
    return `<${tagName} style="font-size: 0.8rem!important;" class="${classes}">${slot}</${tagName}>`;
  }
  static prettyFormatForHtml(arg) {
    const formatted = format(arg, { indent: "    " }).replaceAll(" ", "&nbsp;").replace(/\r\n|\r|\n/g, "<br>").replace(/("[^"]+")/g, this.buildHtmlElement("code", "bold text-green-600 p-0", "$1")).replace(/Array(&nbsp;|\s)+(\[[^\]]+\])/g, this.buildHtmlElement("code", "bold text-gray-500 p-0", "$1$2")).replace(/^(\[[^\]]+\])$/g, this.buildHtmlElement("code", "bold text-gray-500 p-0", "$1")).replace(/(\{.+\})/g, this.buildHtmlElement("code", "text-gray-600", "$1")).replace(
      /(Array|Object|Number|Function|Circular|Symbol|WeakMap|Map)/g,
      this.buildHtmlElement("span", "bold text-yellow-600", "$1")
    ).replaceAll(/(true|false|null|undefined|NaN)/g, this.buildHtmlElement("span", "bold text-indigo-600", "$1")).replace(/(:&nbsp;|[,[\]{}])/g, this.buildHtmlElement("span", "bold text-orange-400", "$1"));
    return this.buildHtmlElement("code", "", formatted);
  }
}
class Payload {
  constructor() {
    __publicField(this, "remotePath", null);
    __publicField(this, "localPath", null);
    __publicField(this, "initialized", false);
    __publicField(this, "data", {
      type: "",
      content: "",
      origin: { function_name: "", file: "", line_number: 0, hostname: "remote" }
    });
  }
  replaceRemotePathWithLocalPath(filePath) {
    if (this.remotePath === null || this.localPath === null) {
      return filePath;
    }
    const pattern = new RegExp(`^${this.remotePath}`);
    return filePath.replace(pattern, this.localPath);
  }
  getContent() {
    return {};
  }
  toArray() {
    if (!this.initialized) {
      this.initialized = true;
      this.data.type = this.getType();
      this.data.content = this.getContent();
      this.data.origin.file = this.replaceRemotePathWithLocalPath(this.data.origin.file);
    }
    return this.data;
  }
  toJson() {
    return JSON.stringify(this.toArray());
  }
}
class BoolPayload extends Payload {
  constructor(value) {
    super();
    __publicField(this, "value");
    this.value = value;
  }
  getType() {
    return "custom";
  }
  getContent() {
    return {
      content: this.value,
      label: "Boolean"
    };
  }
}
class HtmlPayload extends Payload {
  constructor(html = "") {
    super();
    __publicField(this, "html");
    this.html = html;
  }
  getType() {
    return "custom";
  }
  getContent() {
    return {
      content: this.html,
      label: "HTML"
    };
  }
}
class LogPayload extends Payload {
  constructor(values) {
    super();
    __publicField(this, "values");
    this.values = Array.isArray(values) ? values : [values];
  }
  static createForArguments(args) {
    const dumpedArguments = args.map((argument) => {
      return ArgumentConverter.convertToPrimitive(argument).value;
    });
    return new this(dumpedArguments);
  }
  getType() {
    return "log";
  }
  getContent() {
    return {
      values: this.values
    };
  }
}
class NullPayload extends Payload {
  getType() {
    return "custom";
  }
  getContent() {
    return {
      content: null,
      label: "Null"
    };
  }
}
class PayloadFactory {
  constructor(values) {
    __publicField(this, "values");
    this.values = values;
  }
  static createForValues(args) {
    return new this(args).getPayloads();
  }
  static registerPayloadFinder(callable) {
    this.payloadFinder = callable;
  }
  getPayloads() {
    return this.values.map((value) => {
      return this.getPayload(value);
    });
  }
  getPayload(value) {
    if (typeof value === "boolean") {
      return new BoolPayload(value);
    }
    if (value === null) {
      return new NullPayload();
    }
    const convertedResult = ArgumentConverter.convertToPrimitive(value);
    if (convertedResult.isHtml) {
      return new HtmlPayload(convertedResult.value);
    }
    return new LogPayload(convertedResult.value);
  }
}
__publicField(PayloadFactory, "payloadFinder", null);
class CallerPayload extends Payload {
  constructor(frames) {
    super();
    __publicField(this, "frames");
    this.frames = RemovesRayFrames.removeRayFrames(frames);
  }
  getType() {
    return "caller";
  }
  getContent() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const frame = this.frames.slice(0)[0] || null;
    const funcNameParts = (_d = (_c = (_b = (_a = frame == null ? void 0 : frame.getFunctionName()) == null ? void 0 : _a.replace("Proxy.", "")) == null ? void 0 : _b.split(".")) == null ? void 0 : _c.slice(0)) != null ? _d : [];
    return {
      frame: {
        file_name: this.replaceRemotePathWithLocalPath((_e = frame == null ? void 0 : frame.getFileName()) != null ? _e : ""),
        line_number: (frame == null ? void 0 : frame.getLineNumber()) || 0,
        class: (_f = funcNameParts[0]) != null ? _f : "",
        method: funcNameParts ? funcNameParts.slice(1).join(".") : "",
        vendor_frame: (_h = (_g = frame == null ? void 0 : frame.getFileName()) == null ? void 0 : _g.includes("node_modules")) != null ? _h : false
      }
    };
  }
}
class ClearAllPayload extends Payload {
  getType() {
    return "clear_all";
  }
}
class ColorPayload extends Payload {
  constructor(color) {
    super();
    __publicField(this, "color");
    this.color = color;
  }
  getType() {
    return "color";
  }
  getContent() {
    return {
      color: this.color
    };
  }
}
class ConfettiPayload extends Payload {
  getType() {
    return "confetti";
  }
}
class CreateLockPayload extends Payload {
  constructor(name) {
    super();
    __publicField(this, "name");
    this.name = name;
  }
  getType() {
    return "create_lock";
  }
  getContent() {
    return {
      name: this.name
    };
  }
}
class CustomPayload extends Payload {
  constructor(content, label = "") {
    super();
    __publicField(this, "content");
    __publicField(this, "label");
    this.content = content;
    this.label = label;
  }
  getType() {
    return "custom";
  }
  getContent() {
    return {
      content: this.content,
      label: this.label
    };
  }
}
function randomInteger(minimum, maximum) {
  if (maximum === void 0) {
    maximum = minimum;
    minimum = 0;
  }
  if (typeof minimum !== "number" || typeof maximum !== "number") {
    throw new TypeError("Expected all arguments to be numbers");
  }
  return Math.floor(Math.random() * (maximum - minimum + 1) + minimum);
}
const sleep = (seconds) => {
  return usleep(seconds * 1e3);
};
const usleep = (milliseconds) => {
  const start = (/* @__PURE__ */ new Date()).getTime();
  while ((/* @__PURE__ */ new Date()).getTime() < start + milliseconds) {
  }
};
const encodeHtmlEntities = (str) => {
  const escapeChars = {
    "¢": "cent",
    "£": "pound",
    "¥": "yen",
    "€": "euro",
    "©": "copy",
    "®": "reg",
    "<": "lt",
    ">": "gt",
    '"': "quot",
    "&": "amp",
    "'": "#39"
  };
  const chars = Object.keys(escapeChars);
  const regex = new RegExp(`[${chars.join("")}]`, "g");
  return str.replace(regex, (m) => `&${escapeChars[m]};`);
};
const spacesToHtmlSpaces = (spaces) => {
  return "&nbsp;".repeat(spaces.length);
};
const encodeNewLinesToHtml = (str) => {
  return str.replace(/(\r\n|\r|\n)/g, "<br>");
};
const formatHtmlForDisplay = (html, options = { encodeEntities: true }) => {
  if (options.encodeEntities) {
    html = encodeHtmlEntities(html);
  }
  return encodeNewLinesToHtml(
    html.replace(/^(\s+)/gm, (m) => `${spacesToHtmlSpaces(m)}`)
    // preserve indentation spaces
  );
};
const nonCryptoUuidV4 = () => {
  const v4options = {
    random: [
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255)
    ]
  };
  return v4(v4options).toString();
};
const end = (arr) => arr.length ? arr[arr.length - 1] : false;
function toPath(urlOrPath) {
  return urlOrPath instanceof URL ? fileURLToPath(urlOrPath) : urlOrPath;
}
function md5(inputString) {
  const hc = "0123456789abcdef";
  function rh(n) {
    let j, s = "";
    for (j = 0; j <= 3; j++)
      s += hc.charAt(n >> j * 8 + 4 & 15) + hc.charAt(n >> j * 8 & 15);
    return s;
  }
  function ad(x2, y) {
    const l = (x2 & 65535) + (y & 65535);
    const m = (x2 >> 16) + (y >> 16) + (l >> 16);
    return m << 16 | l & 65535;
  }
  function rl(n, c2) {
    return n << c2 | n >>> 32 - c2;
  }
  function cm(q, a2, b2, x2, s, t) {
    return ad(rl(ad(ad(a2, q), ad(x2, t)), s), b2);
  }
  function ff(a2, b2, c2, d2, x2, s, t) {
    return cm(b2 & c2 | ~b2 & d2, a2, b2, x2, s, t);
  }
  function gg(a2, b2, c2, d2, x2, s, t) {
    return cm(b2 & d2 | c2 & ~d2, a2, b2, x2, s, t);
  }
  function hh(a2, b2, c2, d2, x2, s, t) {
    return cm(b2 ^ c2 ^ d2, a2, b2, x2, s, t);
  }
  function ii(a2, b2, c2, d2, x2, s, t) {
    return cm(c2 ^ (b2 | ~d2), a2, b2, x2, s, t);
  }
  function sb(x2) {
    let i2;
    const nblk = (x2.length + 8 >> 6) + 1;
    const blks = new Array(nblk * 16);
    for (i2 = 0; i2 < nblk * 16; i2++)
      blks[i2] = 0;
    for (i2 = 0; i2 < x2.length; i2++)
      blks[i2 >> 2] |= x2.charCodeAt(i2) << i2 % 4 * 8;
    blks[i2 >> 2] |= 128 << i2 % 4 * 8;
    blks[nblk * 16 - 2] = x2.length * 8;
    return blks;
  }
  let i, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878, olda, oldb, oldc, oldd;
  const x = sb(`${inputString}`);
  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;
    a = ff(a, b, c, d, x[i + 0], 7, -680876936);
    d = ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = ff(c, d, a, b, x[i + 10], 17, -42063);
    b = ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = gg(b, c, d, a, x[i + 0], 20, -373897302);
    a = gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = hh(a, b, c, d, x[i + 5], 4, -378558);
    d = hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = hh(d, a, b, c, x[i + 0], 11, -358537222);
    c = hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = ii(a, b, c, d, x[i + 0], 6, -198630844);
    d = ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = ad(a, olda);
    b = ad(b, oldb);
    c = ad(c, oldc);
    d = ad(d, oldd);
  }
  return rh(a) + rh(b) + rh(c) + rh(d);
}
function fileURLToPath(url) {
  try {
    const urlObject = url instanceof URL ? url : new URL(url);
    return decodeURIComponent(urlObject.pathname);
  } catch (error) {
    throw new Error("Invalid URL.");
  }
}
function formatDateExtended(date, format2 = "YYYY-MM-DD HH:mm:ss") {
  const pad = (number) => number < 10 ? `0${number}` : number;
  const getTzName = (date2) => {
    const tzNameMatch = new Intl.DateTimeFormat("en", { timeZoneName: "short" }).formatToParts(date2).find((part) => part.type === "timeZoneName");
    return tzNameMatch ? tzNameMatch.value : "";
  };
  const tokens = {
    // Year
    YYYY: () => date.getFullYear(),
    YY: () => String(date.getFullYear()).slice(-2),
    // Month
    MM: () => pad(date.getMonth() + 1),
    M: () => date.getMonth() + 1,
    // Day
    DD: () => pad(date.getDate()),
    D: () => date.getDate(),
    // Hours
    HH: () => pad(date.getHours()),
    H: () => date.getHours(),
    hh: () => pad(date.getHours() % 12 || 12),
    h: () => date.getHours() % 12 || 12,
    // Minutes
    mm: () => pad(date.getMinutes()),
    m: () => date.getMinutes(),
    // Seconds
    ss: () => pad(date.getSeconds()),
    s: () => date.getSeconds(),
    // AM/PM
    A: () => date.getHours() < 12 ? "AM" : "PM",
    a: () => date.getHours() < 12 ? "am" : "pm",
    T: () => getTzName(date),
    Z: () => {
      const offset = date.getTimezoneOffset();
      return `${(offset > 0 ? "-" : "+") + pad(Math.floor(Math.abs(offset) / 60))}:${pad(Math.abs(offset) % 60)}`;
    },
    z: () => {
      const offset = date.getTimezoneOffset();
      return `${(offset > 0 ? "-" : "+") + pad(Math.floor(Math.abs(offset) / 60)) + pad(Math.abs(offset) % 60)}`;
    }
    // Escape character is handled below in the loop
  };
  let formattedDate = "";
  let escapeNext = false;
  for (let i = 0; i < format2.length; i++) {
    if (format2[i] === "[") {
      escapeNext = true;
      continue;
    }
    if (format2[i] === "]") {
      escapeNext = false;
      continue;
    }
    if (escapeNext) {
      formattedDate += format2[i];
      continue;
    }
    const twoCharToken = format2.substring(i, i + 2);
    const fourCharToken = format2.substring(i, i + 4);
    if (tokens[fourCharToken]) {
      formattedDate += tokens[fourCharToken]();
      i += 3;
    } else if (tokens[twoCharToken]) {
      formattedDate += tokens[twoCharToken]();
      i += 1;
    } else {
      formattedDate += format2[i];
    }
  }
  return formattedDate;
}
const getType = (item) => {
  if (typeof item === "object") {
    const deepType = Object.prototype.toString.call(item).slice(8, -1).toLowerCase();
    if (deepType === "generatorfunction") {
      return "function";
    }
    if (deepType.match(/^(array|bigint|date|error|function|generator|regexp|symbol)$/)) {
      return deepType;
    }
  }
  return typeof item;
};
class DatePayload extends Payload {
  constructor(date, format2 = "YYYY-MM-DD hh:mm:ss") {
    super();
    __publicField(this, "date");
    __publicField(this, "format");
    this.date = date;
    this.format = format2;
  }
  getType() {
    return "carbon";
  }
  getContent() {
    return {
      formatted: this.getFormatted(),
      timestamp: this.getTimestamp(),
      timezone: this.getTimezoneName()
    };
  }
  getTimestamp() {
    if (!this.date) {
      return null;
    }
    return this.date.getTime() / 1e3;
  }
  getFormatted() {
    if (!this.date) {
      return "--";
    }
    return formatDateExtended(this.date, this.format);
  }
  getTimezoneName() {
    if (!this.date) {
      return "--";
    }
    return formatDateExtended(this.date, "T");
  }
}
class DecodedJsonPayload extends Payload {
  // eslint-disable-next-line no-unused-vars
  constructor(value) {
    super();
    this.value = value;
  }
  getType() {
    return "custom";
  }
  getContent() {
    const decodedJson = JSON.parse(this.value);
    return {
      // TODO: use ArgumentConverter
      content: decodedJson,
      //ArgumentConverter::convertToPrimitive(decodedJson),
      label: "JSON"
    };
  }
}
class ErrorPayload extends Payload {
  constructor(err, label = "Error") {
    super();
    __publicField(this, "err");
    __publicField(this, "label");
    this.err = err;
    this.label = label;
  }
  getType() {
    return "custom";
  }
  getContent() {
    return {
      content: this.formatError(),
      label: this.label
    };
  }
  formatError() {
    return `<span class="text-red-400 bold">${this.err.name}</span>: <br><span class="pl-5 text-gray-500">${this.err.message}</span>`;
  }
}
class EventPayload extends Payload {
  constructor(eventName, payload) {
    super();
    __publicField(this, "eventName");
    __publicField(this, "payload");
    this.eventName = eventName;
    this.payload = payload;
  }
  getType() {
    return "event";
  }
  getContent() {
    return {
      name: this.eventName,
      event: this.payload[0],
      payload: ArgumentConverter.convertToPrimitive(this.payload).value,
      class_based_event: true
    };
  }
}
class ExceptionPayload extends Payload {
  constructor(exception, meta = {}) {
    super();
    __publicField(this, "exception");
    __publicField(this, "meta", {});
    // eslint-disable-next-line no-undef
    __publicField(this, "stack");
    this.exception = exception;
    this.meta = meta;
  }
  static async make(exception, meta = {}) {
    const result = new ExceptionPayload(exception, meta);
    result.stack = await Stacktrace.get();
    return result;
  }
  getType() {
    return "exception";
  }
  getContent() {
    return {
      class: this.exception.name,
      message: this.exception.message,
      frames: this.getFrames(),
      meta: this.meta
    };
  }
  getFrames() {
    return this.stack.slice(1).map((frame) => {
      var _a, _b, _c, _d;
      const funcNameParts = (_b = (_a = frame.functionName) == null ? void 0 : _a.split(".")) != null ? _b : ["unknown", "unknown"];
      const methodName = funcNameParts.pop();
      let className = typeof frame.functionName !== "string" ? "unknown" : funcNameParts.pop();
      if (typeof frame.functionName === "undefined") {
        className = "unknown";
      }
      const result = {
        file_name: this.replaceRemotePathWithLocalPath((_c = frame.getFileName()) != null ? _c : ""),
        line_number: frame.getLineNumber(),
        class: className,
        method: typeof frame.fileName === "undefined" ? "<anonymous>" : methodName,
        vendor_frame: (_d = frame.getFileName()) == null ? void 0 : _d.includes("node_modules"),
        snippet: []
      };
      return result;
    }).filter((obj) => !obj.file_name.startsWith("node:")).filter((obj) => !obj.file_name.includes("jest-circus")).filter((obj) => obj.class !== "Ray" && obj.method !== "exception");
  }
}
class HideAppPayload extends Payload {
  getType() {
    return "hide_app";
  }
}
class HidePayload extends Payload {
  getType() {
    return "hide";
  }
}
class HtmlMarkupPayload extends Payload {
  constructor(value, options = { highlight: "none" }) {
    super();
    __publicField(this, "value");
    __publicField(this, "options");
    this.value = value;
    this.options = options;
  }
  getType() {
    return "custom";
  }
  getContent() {
    const content = this.formatMarkupForDisplay(this.value);
    return {
      content,
      label: "Markup"
    };
  }
  formatMarkupForDisplay(markup) {
    const content = this.formatAndIndentMarkup(markup);
    return this.highlightHtmlMarkup(formatHtmlForDisplay(content, { encodeEntities: true }));
  }
  formatAndIndentMarkup(markup) {
    return formatXml(markup.toString(), {
      indentation: "    ",
      collapseContent: true,
      lineSeparator: "\n"
    });
  }
  highlightHtmlMarkup(markup) {
    return markup.replace(/&quot;/g, '"').replace(/="([^"]+)"/g, `=<span style='color:#16A34A;'>&quot;$1&quot;</span>`).replace(/(&lt;[A-Za-z\d-]+)(\s|&nbsp;|&gt;)/g, '<span style="color:#1D4ED8;">$1</span>$2').replace(/(&lt;\/[A-Za-z\d-]+)(&gt;)/g, '<span style="color:#1D4ED8;">$1$2</span>');
  }
}
class ImagePayload extends Payload {
  constructor(location) {
    super();
    __publicField(this, "location");
    this.location = location;
  }
  getType() {
    return "custom";
  }
  getContent() {
    const location = this.location.replace('"', '\\\\"');
    return {
      content: `<img src="${location}" alt="" />`,
      label: "Image"
    };
  }
}
class JsonStringPayload extends Payload {
  constructor(value) {
    super();
    __publicField(this, "value");
    this.value = value;
  }
  getType() {
    return "json_string";
  }
  getContent() {
    return {
      value: JSON.stringify(this.value)
    };
  }
}
class LabelPayload extends Payload {
  constructor(label) {
    super();
    __publicField(this, "label");
    this.label = label;
  }
  getType() {
    return "label";
  }
  getContent() {
    return {
      label: this.label
    };
  }
}
class MeasurePayload extends Payload {
  constructor(name, stopwatchEvent) {
    super();
    /** @var string */
    __publicField(this, "name");
    __publicField(this, "isNewTimer", false);
    __publicField(this, "totalTime", 0);
    __publicField(this, "maxMemoryUsageDuringTotalTime", 0);
    __publicField(this, "timeSinceLastCall", 0);
    __publicField(this, "maxMemoryUsageSinceLastCall", 0);
    this.name = name;
    this.totalTime = stopwatchEvent.getDuration();
    this.maxMemoryUsageDuringTotalTime = stopwatchEvent.getMemory();
    const periods = stopwatchEvent.getPeriods();
    if (periods.length > 1) {
      this.timeSinceLastCall = end(periods);
      this.maxMemoryUsageSinceLastCall = 0;
    }
  }
  getType() {
    return "measure";
  }
  concernsNewTimer() {
    this.isNewTimer = true;
    this.totalTime = 0;
    this.maxMemoryUsageDuringTotalTime = 0;
    this.timeSinceLastCall = 0;
    this.maxMemoryUsageSinceLastCall = 0;
    return this;
  }
  getContent() {
    return {
      name: this.name,
      is_new_timer: this.isNewTimer,
      total_time: this.totalTime,
      max_memory_usage_during_total_time: this.maxMemoryUsageDuringTotalTime,
      time_since_last_call: this.timeSinceLastCall,
      max_memory_usage_since_last_call: this.maxMemoryUsageSinceLastCall
    };
  }
}
class NewScreenPayload extends Payload {
  constructor(name) {
    super();
    __publicField(this, "name");
    this.name = name;
  }
  getType() {
    return "new_screen";
  }
  getContent() {
    return {
      name: this.name
    };
  }
}
class NotifyPayload extends Payload {
  constructor(text) {
    super();
    __publicField(this, "text");
    this.text = text;
  }
  getType() {
    return "notify";
  }
  getContent() {
    return {
      value: this.text
    };
  }
}
class RemovePayload extends Payload {
  getType() {
    return "remove";
  }
}
class ScreenColorPayload extends Payload {
  constructor(color) {
    super();
    __publicField(this, "color");
    this.color = color;
  }
  getType() {
    return "screen_color";
  }
  getContent() {
    return {
      color: this.color
    };
  }
}
class SeparatorPayload extends Payload {
  getType() {
    return "separator";
  }
}
class ShowAppPayload extends Payload {
  getType() {
    return "show_app";
  }
}
class SizePayload extends Payload {
  constructor(size) {
    super();
    __publicField(this, "size");
    this.size = size;
  }
  getType() {
    return "size";
  }
  getContent() {
    return {
      size: this.size
    };
  }
}
class TablePayload extends Payload {
  constructor(values, label = "Table") {
    super();
    __publicField(this, "values");
    __publicField(this, "label");
    this.values = values;
    this.label = label;
  }
  getType() {
    return "table";
  }
  getContent() {
    const values = this.getValues();
    return {
      values,
      label: this.label
    };
  }
  getValues() {
    if (Array.isArray(this.values)) {
      return this.values.map((item) => ArgumentConverter.convertToPrimitive(item).value);
    }
    const values = {};
    for (const prop in this.values) {
      values[prop] = ArgumentConverter.convertToPrimitive(this.values[prop]).value;
    }
    return values;
  }
}
class TextPayload extends Payload {
  // eslint-disable-next-line no-unused-vars
  constructor(text) {
    super();
    this.text = text;
  }
  getType() {
    return "custom";
  }
  getContent() {
    return {
      content: formatHtmlForDisplay(this.text, { encodeEntities: true }),
      label: "Text"
    };
  }
}
class TracePayload extends Payload {
  constructor(frames) {
    super();
    __publicField(this, "frames");
    __publicField(this, "startFromIndexNum", null);
    __publicField(this, "limitNum", null);
    this.frames = RemovesRayFrames.removeRayFrames(frames);
  }
  getType() {
    return "trace";
  }
  getContent() {
    var _a;
    let frames = this.frames.map((frame) => {
      var _a2, _b, _c, _d;
      const funcNameParts = (_a2 = frame.getFunctionName()) == null ? void 0 : _a2.replace("Proxy.", "").split(".").slice(0);
      const className = (funcNameParts == null ? void 0 : funcNameParts.length) ? funcNameParts.shift() : "";
      const methodName = (_b = funcNameParts == null ? void 0 : funcNameParts.join(".")) != null ? _b : "";
      return {
        file_name: this.replaceRemotePathWithLocalPath((_c = frame.getFileName()) != null ? _c : ""),
        line_number: frame.getLineNumber(),
        class: className,
        method: methodName,
        vendor_frame: (_d = frame.getFileName()) == null ? void 0 : _d.includes("node_modules")
      };
    });
    if (this.limitNum !== null) {
      frames = frames.slice((_a = this.startFromIndexNum) != null ? _a : 0, this.limitNum);
    }
    return { frames };
  }
}
class XmlPayload extends Payload {
  constructor(value) {
    super();
    __publicField(this, "value");
    this.value = value;
  }
  getType() {
    return "custom";
  }
  getContent() {
    const content = this.formatXmlForDisplay(this.value);
    return {
      content,
      label: "XML"
    };
  }
  formatXmlForDisplay(xml) {
    const content = this.formatAndIndentXml(xml);
    return this.encodeXml(content);
  }
  encodeXml(xml) {
    return formatHtmlForDisplay(xml, { encodeEntities: true });
  }
  formatAndIndentXml(xml) {
    return formatXml(xml.toString(), {
      indentation: "    ",
      collapseContent: true,
      lineSeparator: "\n"
    });
  }
}
class Request {
  constructor(uuid, payloads, meta = {}) {
    __publicField(this, "uuid");
    __publicField(this, "payloads");
    __publicField(this, "meta");
    this.uuid = uuid;
    this.payloads = payloads;
    this.meta = meta;
  }
  toArray() {
    return {
      uuid: this.uuid,
      payloads: this.payloads.map((payload) => payload.toArray()),
      meta: this.meta
    };
  }
  toJson() {
    return JSON.stringify(this.toArray());
  }
}
class Settings {
  constructor(settings2) {
    __publicField(this, "enable", true);
    __publicField(this, "_host", "localhost");
    __publicField(this, "_port", 23517);
    __publicField(this, "_scheme", "http");
    __publicField(this, "remote_path", null);
    __publicField(this, "local_path", null);
    __publicField(this, "always_send_raw_values", false);
    __publicField(this, "intercept_console_log", false);
    __publicField(this, "enabled_callback", null);
    __publicField(this, "sent_payload_callback", null);
    __publicField(this, "sending_payload_callback", null);
    __publicField(this, "originalSettings");
    this.originalSettings = Object.assign({}, settings2);
    for (const prop in settings2) {
      this[prop] = settings2[prop];
    }
  }
  set host(value) {
    this._host = value;
    Ray.useClient(new Client(this.port, this.host, this.scheme));
  }
  get host() {
    return this._host;
  }
  set port(value) {
    this._port = value;
    Ray.useClient(new Client(this.port, this.host, this.scheme));
  }
  get port() {
    return this._port;
  }
  get scheme() {
    return this._scheme;
  }
  set scheme(value) {
    this._scheme = value;
    Ray.useClient(new Client(this.port, this.host, this.scheme));
  }
  toObject() {
    return this.originalSettings;
  }
}
class StopwatchEvent {
  constructor(sw, lapTime = null) {
    __publicField(this, "name");
    __publicField(this, "laps", []);
    __publicField(this, "startedAt");
    __publicField(this, "endedAt");
    __publicField(this, "lapTime");
    var _a;
    this.name = (_a = sw.name) == null ? void 0 : _a.slice(0);
    this.laps = sw.laps.slice(0);
    this.startedAt = sw.startedAt;
    this.endedAt = sw.endedAt;
    this.lapTime = lapTime != null ? lapTime : (/* @__PURE__ */ new Date()).getTime();
  }
  getDuration() {
    return this.laps.reduce((prev, cur) => cur + prev, 0);
  }
  // eslint-disable-next-line no-unused-vars
  getMemory(callback = null) {
    return 0;
  }
  getPeriods() {
    return this.laps.slice();
  }
  getPreviousDuration() {
    return end(this.laps) - ((/* @__PURE__ */ new Date()).getTime() - this.lapTime);
  }
}
class Stopwatch {
  constructor(name = void 0) {
    __publicField(this, "name");
    __publicField(this, "laps", []);
    __publicField(this, "startedAt", 0);
    __publicField(this, "endedAt", 0);
    this.name = name;
    this.laps = [];
    this.startedAt = 0;
    this.endedAt = 0;
  }
  initialize(name) {
    this.name = name;
    this.laps = [];
    this.startedAt = 0;
    this.endedAt = 0;
  }
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  start(name) {
    this.startedAt = (/* @__PURE__ */ new Date()).getTime();
    return new StopwatchEvent(this);
  }
  lap() {
    const lapTime = (/* @__PURE__ */ new Date()).getTime();
    const duration = lapTime - this.startedAt;
    this.laps.push(duration - this.totalDuration());
    return new StopwatchEvent(this, lapTime);
  }
  stop() {
    this.endedAt = (/* @__PURE__ */ new Date()).getTime();
    const duration = this.endedAt - this.startedAt;
    this.laps.push(duration - this.totalDuration());
    return new StopwatchEvent(this);
  }
  totalDuration() {
    return this.laps.reduce((prev, cur) => cur + prev, 0);
  }
  reset() {
    this.initialize(this.name);
    return this;
  }
  getLaps() {
    return this.laps;
  }
}
class Counters {
  constructor() {
    __publicField(this, "counters", {});
  }
  async increment(name) {
    if (typeof this.counters[name] === "undefined") {
      this.counters[name] = [await ray(), 0];
    }
    const data = this.counters[name];
    const ray$1 = data[0];
    const times = data[1];
    const newTimes = times + 1;
    this.counters[name] = [ray$1, newTimes];
    return [ray$1, newTimes];
  }
  get(name) {
    if (typeof this.counters[name] === "undefined") {
      return 0;
    }
    return this.counters[name][1];
  }
  clear() {
    this.counters = [];
  }
  setRay(name, ray2) {
    this.counters[name][0] = ray2;
  }
  getCounters() {
    return this.counters;
  }
}
class Limiters {
  constructor() {
    __publicField(this, "counters", {});
  }
  initialize(origin, limit) {
    const fingerprint = `${origin.file}:${origin.line_number}`;
    if (typeof this.counters[fingerprint] === "undefined") {
      this.counters[fingerprint] = { counter: 0, limit, valid: true };
    }
    return this.counters[fingerprint];
  }
  increment(origin) {
    const name = `${origin.file}:${origin.line_number}`;
    if (typeof this.counters[name] === "undefined") {
      return { counter: 0, limit: 0, valid: false };
    }
    const { counter, limit, valid } = this.counters[name];
    this.counters[name] = { counter: counter + 1, limit, valid };
    return this.counters[name];
  }
  canSendPayload(origin) {
    const name = `${origin.file}:${origin.line_number}`;
    if (typeof this.counters[name] === "undefined") {
      return true;
    }
    const { counter, limit, valid } = this.counters[name];
    return valid && (counter < limit || limit <= 0);
  }
}
class CacheStore {
  constructor(clock) {
    __publicField(this, "store", []);
    __publicField(this, "clock");
    this.clock = clock;
  }
  hit() {
    this.store.push(this.clock.now());
    return this;
  }
  clear() {
    this.store = [];
    return this;
  }
  count() {
    return this.store.length;
  }
  countLastSecond() {
    const lastSecond = this.clock.now().subSeconds(1);
    let amount = 0;
    this.store.forEach((item) => {
      if (this.isBetween(item, lastSecond, this.clock.now())) {
        amount++;
      }
    });
    return amount;
  }
  isBetween(toCheck, start, end2) {
    return toCheck.getTimestamp() >= start.getTimestamp() && toCheck.getTimestamp() <= end2.getTimestamp();
  }
}
class Clock {
}
class DateImmutable {
  constructor(date = null) {
    __publicField(this, "dateStr");
    __publicField(this, "dateTs");
    __publicField(this, "_date");
    this._date = date != null ? date : /* @__PURE__ */ new Date();
    this.date = this._date;
    this.dateStr = this.date.toISOString();
    this.dateTs = this.date.getTime();
  }
  get date() {
    return this._date;
  }
  set date(value) {
    this.dateTs = value.getTime();
    this.dateStr = value.toISOString();
  }
  static createFrom(date) {
    return new DateImmutable(date);
  }
  getTimestamp() {
    return Math.floor(this.dateTs / 1e3);
  }
  addSeconds(seconds) {
    return DateImmutable.createFrom(new Date(this.dateTs + seconds * 1e3));
  }
  subSeconds(seconds) {
    return DateImmutable.createFrom(new Date(this.dateTs - seconds * 1e3));
  }
}
class SystemClock extends Clock {
  now() {
    return new DateImmutable();
  }
}
class RateLimiter {
  constructor(maxCalls = null, maxPerSecond = null) {
    __publicField(this, "maxCalls");
    __publicField(this, "maxPerSecond");
    __publicField(this, "cache");
    __publicField(this, "notified", false);
    this.maxCalls = maxCalls;
    this.maxPerSecond = maxPerSecond;
    this.cache = new CacheStore(new SystemClock());
  }
  static disabled() {
    return new RateLimiter(null, null);
  }
  hit() {
    this.cache.hit();
    return this;
  }
  max(maxCalls = null) {
    this.maxCalls = maxCalls;
    return this;
  }
  perSecond(callsPerSecond = null) {
    this.maxPerSecond = callsPerSecond;
    return this;
  }
  isMaxReached() {
    if (this.maxCalls === null) {
      return false;
    }
    const reached = this.cache.count() >= this.maxCalls;
    if (!reached) {
      this.notified = false;
    }
    return reached;
  }
  isMaxPerSecondReached() {
    if (this.maxPerSecond === null) {
      return false;
    }
    const reached = this.cache.countLastSecond() >= this.maxPerSecond;
    if (reached === false) {
      this.notified = false;
    }
    return reached;
  }
  clear() {
    this.maxCalls = null;
    this.maxPerSecond = null;
    this.cache.clear();
    return this;
  }
  isNotified() {
    return this.notified;
  }
  notify() {
    this.notified = true;
  }
  getCache() {
    return this.cache;
  }
}
var SendRequestCallbackType = /* @__PURE__ */ ((SendRequestCallbackType2) => {
  SendRequestCallbackType2["Sending"] = "sending";
  SendRequestCallbackType2["Sent"] = "sent";
  return SendRequestCallbackType2;
})(SendRequestCallbackType || {});
const PACKAGE_VERSION = "2.1.2";
const copyProps = (dest, src, exclude = []) => {
  const props = Object.getOwnPropertyDescriptors(src);
  for (let prop of exclude)
    delete props[prop];
  Object.defineProperties(dest, props);
};
const protoChain = (obj, currentChain = [obj]) => {
  const proto = Object.getPrototypeOf(obj);
  if (proto === null)
    return currentChain;
  return protoChain(proto, [...currentChain, proto]);
};
const nearestCommonProto = (...objs) => {
  if (objs.length === 0)
    return void 0;
  let commonProto = void 0;
  const protoChains = objs.map((obj) => protoChain(obj));
  while (protoChains.every((protoChain2) => protoChain2.length > 0)) {
    const protos = protoChains.map((protoChain2) => protoChain2.pop());
    const potentialCommonProto = protos[0];
    if (protos.every((proto) => proto === potentialCommonProto))
      commonProto = potentialCommonProto;
    else
      break;
  }
  return commonProto;
};
const hardMixProtos = (ingredients, constructor, exclude = []) => {
  var _a;
  const base = (_a = nearestCommonProto(...ingredients)) !== null && _a !== void 0 ? _a : Object.prototype;
  const mixedProto = Object.create(base);
  const visitedProtos = protoChain(base);
  for (let prototype of ingredients) {
    let protos = protoChain(prototype);
    for (let i = protos.length - 1; i >= 0; i--) {
      let newProto = protos[i];
      if (visitedProtos.indexOf(newProto) === -1) {
        copyProps(mixedProto, newProto, ["constructor", ...exclude]);
        visitedProtos.push(newProto);
      }
    }
  }
  mixedProto.constructor = constructor;
  return mixedProto;
};
const unique = (arr) => arr.filter((e, i) => arr.indexOf(e) == i);
const getIngredientWithProp = (prop, ingredients) => {
  const protoChains = ingredients.map((ingredient) => protoChain(ingredient));
  let protoDepth = 0;
  let protosAreLeftToSearch = true;
  while (protosAreLeftToSearch) {
    protosAreLeftToSearch = false;
    for (let i = ingredients.length - 1; i >= 0; i--) {
      const searchTarget = protoChains[i][protoDepth];
      if (searchTarget !== void 0 && searchTarget !== null) {
        protosAreLeftToSearch = true;
        if (Object.getOwnPropertyDescriptor(searchTarget, prop) != void 0) {
          return protoChains[i][0];
        }
      }
    }
    protoDepth++;
  }
  return void 0;
};
const proxyMix = (ingredients, prototype = Object.prototype) => new Proxy({}, {
  getPrototypeOf() {
    return prototype;
  },
  setPrototypeOf() {
    throw Error("Cannot set prototype of Proxies created by ts-mixer");
  },
  getOwnPropertyDescriptor(_, prop) {
    return Object.getOwnPropertyDescriptor(getIngredientWithProp(prop, ingredients) || {}, prop);
  },
  defineProperty() {
    throw new Error("Cannot define new properties on Proxies created by ts-mixer");
  },
  has(_, prop) {
    return getIngredientWithProp(prop, ingredients) !== void 0 || prototype[prop] !== void 0;
  },
  get(_, prop) {
    return (getIngredientWithProp(prop, ingredients) || prototype)[prop];
  },
  set(_, prop, val) {
    const ingredientWithProp = getIngredientWithProp(prop, ingredients);
    if (ingredientWithProp === void 0)
      throw new Error("Cannot set new properties on Proxies created by ts-mixer");
    ingredientWithProp[prop] = val;
    return true;
  },
  deleteProperty() {
    throw new Error("Cannot delete properties on Proxies created by ts-mixer");
  },
  ownKeys() {
    return ingredients.map(Object.getOwnPropertyNames).reduce((prev, curr) => curr.concat(prev.filter((key) => curr.indexOf(key) < 0)));
  }
});
const softMixProtos = (ingredients, constructor) => proxyMix([...ingredients, { constructor }]);
const settings = {
  initFunction: null,
  staticsStrategy: "copy",
  prototypeStrategy: "copy",
  decoratorInheritance: "deep"
};
const mixins = /* @__PURE__ */ new WeakMap();
const getMixinsForClass = (clazz) => mixins.get(clazz);
const registerMixins = (mixedClass, constituents) => mixins.set(mixedClass, constituents);
const hasMixin = (instance, mixin) => {
  if (instance instanceof mixin)
    return true;
  const constructor = instance.constructor;
  const visited = /* @__PURE__ */ new Set();
  let frontier = /* @__PURE__ */ new Set();
  frontier.add(constructor);
  while (frontier.size > 0) {
    if (frontier.has(mixin))
      return true;
    frontier.forEach((item) => visited.add(item));
    const newFrontier = /* @__PURE__ */ new Set();
    frontier.forEach((item) => {
      var _a;
      const itemConstituents = (_a = mixins.get(item)) !== null && _a !== void 0 ? _a : protoChain(item.prototype).map((proto) => proto.constructor).filter((item2) => item2 !== null);
      if (itemConstituents)
        itemConstituents.forEach((constituent) => {
          if (!visited.has(constituent) && !frontier.has(constituent))
            newFrontier.add(constituent);
        });
    });
    frontier = newFrontier;
  }
  return false;
};
const mergeObjectsOfDecorators = (o1, o2) => {
  var _a, _b;
  const allKeys = unique([...Object.getOwnPropertyNames(o1), ...Object.getOwnPropertyNames(o2)]);
  const mergedObject = {};
  for (let key of allKeys)
    mergedObject[key] = unique([...(_a = o1 === null || o1 === void 0 ? void 0 : o1[key]) !== null && _a !== void 0 ? _a : [], ...(_b = o2 === null || o2 === void 0 ? void 0 : o2[key]) !== null && _b !== void 0 ? _b : []]);
  return mergedObject;
};
const mergePropertyAndMethodDecorators = (d1, d2) => {
  var _a, _b, _c, _d;
  return {
    property: mergeObjectsOfDecorators((_a = d1 === null || d1 === void 0 ? void 0 : d1.property) !== null && _a !== void 0 ? _a : {}, (_b = d2 === null || d2 === void 0 ? void 0 : d2.property) !== null && _b !== void 0 ? _b : {}),
    method: mergeObjectsOfDecorators((_c = d1 === null || d1 === void 0 ? void 0 : d1.method) !== null && _c !== void 0 ? _c : {}, (_d = d2 === null || d2 === void 0 ? void 0 : d2.method) !== null && _d !== void 0 ? _d : {})
  };
};
const mergeDecorators = (d1, d2) => {
  var _a, _b, _c, _d, _e, _f;
  return {
    class: unique([...(_a = d1 === null || d1 === void 0 ? void 0 : d1.class) !== null && _a !== void 0 ? _a : [], ...(_b = d2 === null || d2 === void 0 ? void 0 : d2.class) !== null && _b !== void 0 ? _b : []]),
    static: mergePropertyAndMethodDecorators((_c = d1 === null || d1 === void 0 ? void 0 : d1.static) !== null && _c !== void 0 ? _c : {}, (_d = d2 === null || d2 === void 0 ? void 0 : d2.static) !== null && _d !== void 0 ? _d : {}),
    instance: mergePropertyAndMethodDecorators((_e = d1 === null || d1 === void 0 ? void 0 : d1.instance) !== null && _e !== void 0 ? _e : {}, (_f = d2 === null || d2 === void 0 ? void 0 : d2.instance) !== null && _f !== void 0 ? _f : {})
  };
};
const decorators = /* @__PURE__ */ new Map();
const findAllConstituentClasses = (...classes) => {
  var _a;
  const allClasses = /* @__PURE__ */ new Set();
  const frontier = /* @__PURE__ */ new Set([...classes]);
  while (frontier.size > 0) {
    for (let clazz of frontier) {
      const protoChainClasses = protoChain(clazz.prototype).map((proto) => proto.constructor);
      const mixinClasses = (_a = getMixinsForClass(clazz)) !== null && _a !== void 0 ? _a : [];
      const potentiallyNewClasses = [...protoChainClasses, ...mixinClasses];
      const newClasses = potentiallyNewClasses.filter((c) => !allClasses.has(c));
      for (let newClass of newClasses)
        frontier.add(newClass);
      allClasses.add(clazz);
      frontier.delete(clazz);
    }
  }
  return [...allClasses];
};
const deepDecoratorSearch = (...classes) => {
  const decoratorsForClassChain = findAllConstituentClasses(...classes).map((clazz) => decorators.get(clazz)).filter((decorators2) => !!decorators2);
  if (decoratorsForClassChain.length == 0)
    return {};
  if (decoratorsForClassChain.length == 1)
    return decoratorsForClassChain[0];
  return decoratorsForClassChain.reduce((d1, d2) => mergeDecorators(d1, d2));
};
const directDecoratorSearch = (...classes) => {
  const classDecorators = classes.map((clazz) => getDecoratorsForClass(clazz));
  if (classDecorators.length === 0)
    return {};
  if (classDecorators.length === 1)
    return classDecorators[0];
  return classDecorators.reduce((d1, d2) => mergeDecorators(d1, d2));
};
const getDecoratorsForClass = (clazz) => {
  let decoratorsForClass = decorators.get(clazz);
  if (!decoratorsForClass) {
    decoratorsForClass = {};
    decorators.set(clazz, decoratorsForClass);
  }
  return decoratorsForClass;
};
const decorateClass = (decorator) => (clazz) => {
  const decoratorsForClass = getDecoratorsForClass(clazz);
  let classDecorators = decoratorsForClass.class;
  if (!classDecorators) {
    classDecorators = [];
    decoratorsForClass.class = classDecorators;
  }
  classDecorators.push(decorator);
  return decorator(clazz);
};
const decorateMember = (decorator) => (object, key, ...otherArgs) => {
  var _a, _b, _c;
  const decoratorTargetType = typeof object === "function" ? "static" : "instance";
  const decoratorType = typeof object[key] === "function" ? "method" : "property";
  const clazz = decoratorTargetType === "static" ? object : object.constructor;
  const decoratorsForClass = getDecoratorsForClass(clazz);
  const decoratorsForTargetType = (_a = decoratorsForClass === null || decoratorsForClass === void 0 ? void 0 : decoratorsForClass[decoratorTargetType]) !== null && _a !== void 0 ? _a : {};
  decoratorsForClass[decoratorTargetType] = decoratorsForTargetType;
  let decoratorsForType = (_b = decoratorsForTargetType === null || decoratorsForTargetType === void 0 ? void 0 : decoratorsForTargetType[decoratorType]) !== null && _b !== void 0 ? _b : {};
  decoratorsForTargetType[decoratorType] = decoratorsForType;
  let decoratorsForKey = (_c = decoratorsForType === null || decoratorsForType === void 0 ? void 0 : decoratorsForType[key]) !== null && _c !== void 0 ? _c : [];
  decoratorsForType[key] = decoratorsForKey;
  decoratorsForKey.push(decorator);
  return decorator(object, key, ...otherArgs);
};
const decorate = (decorator) => (...args) => {
  if (args.length === 1)
    return decorateClass(decorator)(args[0]);
  return decorateMember(decorator)(...args);
};
function Mixin(...constructors) {
  var _a, _b, _c;
  const prototypes = constructors.map((constructor) => constructor.prototype);
  const initFunctionName = settings.initFunction;
  if (initFunctionName !== null) {
    const initFunctions = prototypes.map((proto) => proto[initFunctionName]).filter((func) => typeof func === "function");
    const combinedInitFunction = function(...args) {
      for (let initFunction of initFunctions)
        initFunction.apply(this, args);
    };
    const extraProto = { [initFunctionName]: combinedInitFunction };
    prototypes.push(extraProto);
  }
  function MixedClass(...args) {
    for (const constructor of constructors)
      copyProps(this, new constructor(...args));
    if (initFunctionName !== null && typeof this[initFunctionName] === "function")
      this[initFunctionName].apply(this, args);
  }
  MixedClass.prototype = settings.prototypeStrategy === "copy" ? hardMixProtos(prototypes, MixedClass) : softMixProtos(prototypes, MixedClass);
  Object.setPrototypeOf(MixedClass, settings.staticsStrategy === "copy" ? hardMixProtos(constructors, null, ["prototype"]) : proxyMix(constructors, Function.prototype));
  let DecoratedMixedClass = MixedClass;
  if (settings.decoratorInheritance !== "none") {
    const classDecorators = settings.decoratorInheritance === "deep" ? deepDecoratorSearch(...constructors) : directDecoratorSearch(...constructors);
    for (let decorator of (_a = classDecorators === null || classDecorators === void 0 ? void 0 : classDecorators.class) !== null && _a !== void 0 ? _a : []) {
      const result = decorator(DecoratedMixedClass);
      if (result) {
        DecoratedMixedClass = result;
      }
    }
    applyPropAndMethodDecorators((_b = classDecorators === null || classDecorators === void 0 ? void 0 : classDecorators.static) !== null && _b !== void 0 ? _b : {}, DecoratedMixedClass);
    applyPropAndMethodDecorators((_c = classDecorators === null || classDecorators === void 0 ? void 0 : classDecorators.instance) !== null && _c !== void 0 ? _c : {}, DecoratedMixedClass.prototype);
  }
  registerMixins(DecoratedMixedClass, constructors);
  return DecoratedMixedClass;
}
const applyPropAndMethodDecorators = (propAndMethodDecorators, target) => {
  const propDecorators = propAndMethodDecorators.property;
  const methodDecorators = propAndMethodDecorators.method;
  if (propDecorators)
    for (let key in propDecorators)
      for (let decorator of propDecorators[key])
        decorator(target, key);
  if (methodDecorators)
    for (let key in methodDecorators)
      for (let decorator of methodDecorators[key])
        decorator(target, key, Object.getOwnPropertyDescriptor(target, key));
};
const mix = (...ingredients) => (decoratedClass) => {
  const mixedClass = Mixin(...ingredients.concat([decoratedClass]));
  Object.defineProperty(mixedClass, "name", {
    value: decoratedClass.name,
    writable: false
  });
  return mixedClass;
};
const _Ray = class _Ray extends Mixin(RayColors, RaySizes, RayScreenColors) {
  constructor(settings2, client = null, uuid = null, inCallback = false) {
    var _a, _b, _c;
    super();
    __publicField(this, "inCallback", false);
    __publicField(this, "settings");
    __publicField(this, "uuid");
    __publicField(this, "limitOrigin", null);
    __publicField(this, "canSendPayload", true);
    __publicField(this, "chaining", false);
    __publicField(this, "chainedPayloads", []);
    if (_Ray.defaultSettings.not_defined === true) {
      _Ray.defaultSettings = {
        enable: true,
        host: "localhost",
        port: 23517,
        scheme: "http",
        local_path: null,
        remote_path: null,
        always_send_raw_values: false,
        enabled_callback: null,
        sending_payload_callback: null,
        sent_payload_callback: null,
        not_defined: false
      };
    }
    _Ray.defaultSettings = Object.assign({}, _Ray.defaultSettings, settings2.toObject());
    this.inCallback = inCallback;
    this.settings = new Settings(_Ray.defaultSettings);
    if (_Ray.enabled === null) {
      _Ray.enabled = this.settings.enable !== false;
    }
    _Ray.client = (_a = client != null ? client : _Ray.client) != null ? _a : new Client(this.settings.port, this.settings.host);
    _Ray._rateLimiter = (_b = _Ray._rateLimiter) != null ? _b : RateLimiter.disabled();
    this.uuid = (_c = uuid != null ? uuid : _Ray.fakeUuid) != null ? _c : nonCryptoUuidV4();
    if (this.settings.intercept_console_log && !this.interceptor().active()) {
      this.interceptor().enable();
    }
    this.loadMacros();
  }
  static create(client = null, uuid = null) {
    if (_Ray.defaultSettings.not_defined === true) {
      _Ray.defaultSettings = {
        enable: true,
        host: "localhost",
        port: 23517,
        scheme: "http",
        local_path: null,
        remote_path: null,
        always_send_raw_values: false,
        not_defined: false,
        intercept_console_log: false,
        enabled_callback: null,
        sending_payload_callback: null,
        sent_payload_callback: null
      };
    }
    const settings2 = new Settings(_Ray.defaultSettings);
    return new this(settings2, client, uuid);
  }
  static useDefaultSettings(settings2) {
    if (_Ray.defaultSettings.not_defined === true) {
      _Ray.defaultSettings = {
        enable: true,
        host: "localhost",
        port: 23517,
        scheme: "http",
        local_path: null,
        remote_path: null,
        always_send_raw_values: false,
        enabled_callback: null,
        sending_payload_callback: null,
        sent_payload_callback: null,
        not_defined: false
      };
    }
    _Ray.defaultSettings = Object.assign({}, _Ray.defaultSettings, settings2);
    _Ray.defaultSettings.not_defined = false;
    _Ray.client = new Client(this.defaultSettings.port, this.defaultSettings.host);
    return this;
  }
  loadMacros() {
    for (const name in _Ray.macros) {
      const handler = _Ray.macros[name];
      this[name] = handler.bind(this);
    }
    return this;
  }
  interceptor() {
    return _Ray.interceptor;
  }
  client() {
    return _Ray.client;
  }
  enable() {
    _Ray.enabled = true;
    return this;
  }
  disable() {
    _Ray.enabled = false;
    return this;
  }
  enabled() {
    if (typeof this.settings.enabled_callback === "function") {
      return _Ray.enabled && this.settings.enabled_callback();
    }
    return _Ray.enabled;
  }
  disabled() {
    return !this.enabled();
  }
  static useClient(client) {
    this.client = client;
  }
  project(projectName) {
    _Ray.projectName = projectName;
    return this;
  }
  newScreen(name = "") {
    const payload = new NewScreenPayload(name);
    return this.sendRequest(payload);
  }
  clearAll() {
    const payload = new ClearAllPayload();
    return this.sendRequest(payload);
  }
  clearScreen() {
    return this.newScreen();
  }
  color(color) {
    const payload = new ColorPayload(color);
    return this.sendRequest(payload);
  }
  confetti() {
    const payload = new ConfettiPayload();
    return this.sendRequest(payload);
  }
  screenColor(color) {
    const payload = new ScreenColorPayload(color);
    return this.sendRequest(payload);
  }
  label(label) {
    const payload = new LabelPayload(label);
    return this.sendRequest(payload);
  }
  size(size) {
    const payload = new SizePayload(size);
    return this.sendRequest(payload);
  }
  remove() {
    const payload = new RemovePayload();
    return this.sendRequest(payload);
  }
  hide() {
    const payload = new HidePayload();
    return this.sendRequest(payload);
  }
  notify(text) {
    const payload = new NotifyPayload(text);
    return this.sendRequest(payload);
  }
  toJson(...values) {
    const payloads = values.map((value) => new JsonStringPayload(value));
    return this.sendRequest(payloads);
  }
  json(...jsons) {
    const payloads = jsons.map((json) => new DecodedJsonPayload(json));
    return this.sendRequest(payloads);
  }
  file(filename) {
    throw new Error("file() unsupported on node-ray/web.");
  }
  image(location) {
    const payload = new ImagePayload(location);
    return this.sendRequest(payload);
  }
  die(status = "") {
    throw new Error(`Ray.die() called: ${status ? status : "no message"}`);
  }
  className(object) {
    return this.send(object.constructor.name);
  }
  error(err) {
    const payload = new ErrorPayload(err, "Error");
    return this.sendRequest(payload).red();
  }
  event(eventName, data = []) {
    const payload = new EventPayload(eventName, data);
    return this.sendRequest(payload);
  }
  async exception(err, meta = {}) {
    const payload = await ExceptionPayload.make(err, meta);
    return await this.sendRequest(payload).red();
  }
  ban() {
    return this.send("🕶");
  }
  charles() {
    return this.send("🎶 🎹 🎷 🕺");
  }
  table(values, label = "Table") {
    const payload = new TablePayload(values, label);
    return this.sendRequest(payload);
  }
  async count(name = null) {
    var _a;
    const caller = await this.getCaller();
    const fingerprint = md5(`${caller == null ? void 0 : caller.getFileName()}${caller == null ? void 0 : caller.getLineNumber()}`);
    const [r, times] = await _Ray.counters.increment((_a = name != null ? name : fingerprint) != null ? _a : "none");
    let message = "Called ";
    if (name) {
      message += `'${name}' `;
    }
    message += `${times} ${times === 1 ? "time" : "times"}.`;
    r.sendCustom(message, "Count");
    return r;
  }
  clearCounters() {
    _Ray.counters.clear();
    return this;
  }
  async pause() {
    _Ray.lockCounter++;
    const lockName = md5(`${(/* @__PURE__ */ new Date()).getTime()}-${_Ray.lockCounter}`);
    const payload = new CreateLockPayload(lockName);
    this.sendRequest(payload);
    return new Promise(async (resolve, reject) => {
      let exists;
      do {
        sleep(1);
        try {
          exists = await _Ray.client.lockExists(lockName);
        } catch (err) {
          reject(err);
          return false;
        }
        if (exists !== true && exists && exists.stop_execution) {
          reject(false);
          return false;
        }
      } while (exists.active);
      resolve(this);
    });
  }
  stopTime(stopwatchName = "") {
    if (stopwatchName === "") {
      _Ray.stopWatches = {};
      return this;
    }
    if (typeof _Ray.stopWatches[stopwatchName] !== "undefined") {
      delete _Ray.stopWatches[stopwatchName];
    }
    return this;
  }
  async caller() {
    const backtrace = await Stacktrace.get();
    const payload = new CallerPayload(backtrace);
    return this.sendRequest(payload);
  }
  async trace() {
    const backtrace = await Stacktrace.get();
    return this.sendRequest(new TracePayload(backtrace));
  }
  measure(stopwatchName = "default") {
    if (stopwatchName instanceof Function) {
      return this.measureClosure(stopwatchName);
    }
    if (typeof _Ray.stopWatches[stopwatchName] === "undefined") {
      const stopwatch2 = this.getStopwatch(stopwatchName);
      _Ray.stopWatches[stopwatchName] = stopwatch2;
      const event2 = stopwatch2.start(stopwatchName);
      const payload2 = this.getMeasurePayload(stopwatchName, event2);
      payload2.concernsNewTimer();
      return this.sendRequest(payload2);
    }
    const stopwatch = _Ray.stopWatches[stopwatchName];
    const event = stopwatch.lap();
    const payload = this.getMeasurePayload(stopwatchName, event);
    return this.sendRequest(payload);
  }
  measureClosure(closure) {
    const stopwatch = this.getStopwatch("closure");
    stopwatch.start("closure");
    closure();
    const event = stopwatch.stop();
    const payload = this.getMeasurePayload("closure", event);
    return this.sendRequest(payload);
  }
  getStopwatch(name) {
    return new Stopwatch(name);
  }
  getMeasurePayload(name, event) {
    return new MeasurePayload(name, event);
  }
  separator() {
    const payload = new SeparatorPayload();
    return this.sendRequest(payload);
  }
  xml(xml) {
    const payload = new XmlPayload(xml);
    return this.sendRequest(payload);
  }
  html(html = "") {
    const payload = new HtmlPayload(html);
    return this.sendRequest(payload);
  }
  text(text = "") {
    const payload = new TextPayload(text);
    return this.sendRequest(payload);
  }
  date(date) {
    const payload = new DatePayload(date);
    return this.sendRequest(payload);
  }
  raw(...args) {
    if (!args.length) {
      return this;
    }
    const payloads = args.map((arg) => LogPayload.createForArguments([arg]));
    return this.sendRequest(payloads);
  }
  send(...args) {
    if (!args.length) {
      return this;
    }
    if (this.settings.always_send_raw_values) {
      return this.raw(...args);
    }
    const payloads = PayloadFactory.createForValues(args);
    return this.sendRequest(payloads);
  }
  pass(argument) {
    this.send(argument);
    return argument;
  }
  showApp() {
    const payload = new ShowAppPayload();
    return this.sendRequest(payload);
  }
  hideApp() {
    const payload = new HideAppPayload();
    return this.sendRequest(payload);
  }
  macro(name, handler) {
    _Ray.macros[name] = handler;
    this[name] = handler.bind(this);
    return this;
  }
  htmlMarkup(html, options = {}) {
    const payload = new HtmlMarkupPayload(html, options);
    return this.sendRequest(payload);
  }
  if(boolOrCallable, callback = null) {
    if (typeof boolOrCallable === "function") {
      boolOrCallable = boolOrCallable();
    }
    if (boolOrCallable && callback !== null) {
      callback(this);
    }
    if (callback === null) {
      this.canSendPayload = boolOrCallable;
    }
    return this;
  }
  async limit(count) {
    const frame = await this.getCaller();
    this.limitOrigin = {
      function_name: frame == null ? void 0 : frame.getFunctionName(),
      file: frame == null ? void 0 : frame.getFileName(),
      line_number: frame == null ? void 0 : frame.getLineNumber(),
      hostname: Hostname.get()
    };
    _Ray.limiters.initialize(this.limitOrigin, count);
    return this;
  }
  async once(...args) {
    const frame = await this.getCaller();
    this.limitOrigin = {
      function_name: frame == null ? void 0 : frame.getFunctionName(),
      file: frame == null ? void 0 : frame.getFileName(),
      line_number: frame == null ? void 0 : frame.getLineNumber(),
      hostname: Hostname.get()
    };
    _Ray.limiters.initialize(this.limitOrigin, 1);
    if (args.length > 0) {
      return this.send(...args);
    }
    return this;
  }
  chain(callback) {
    this.chaining = true;
    callback(this);
    this.chaining = false;
    this.sendRequest(this.chainedPayloads.slice(0));
    this.chainedPayloads = [];
    return this;
  }
  sendCustom(content, label = "") {
    const payload = new CustomPayload(content, label);
    return this.sendRequest(payload);
  }
  async getOriginFrame() {
    const st = await Stacktrace.get();
    let startFrameIndex = st.findIndex((frame) => {
      var _a;
      return (_a = frame.functionName) == null ? void 0 : _a.includes("Ray.sendRequest");
    });
    if (startFrameIndex === -1) {
      startFrameIndex = 0;
    }
    const callerFrames = RemovesRayFrames.removeRayFrames(st.slice(startFrameIndex));
    return callerFrames.slice(0).shift();
  }
  async getCaller() {
    const st = await Stacktrace.get();
    let startFrameIndex = st.findIndex((frame) => {
      var _a;
      return (_a = frame.functionName) == null ? void 0 : _a.includes("Ray.getCaller");
    });
    if (startFrameIndex === -1) {
      startFrameIndex = 0;
    }
    const callerFrames = st.slice(startFrameIndex);
    if (callerFrames.length === 1) {
      return callerFrames.shift();
    }
    return callerFrames.slice(2).shift();
  }
  async getOriginData() {
    const frame = await this.getOriginFrame();
    return {
      function_name: frame == null ? void 0 : frame.getFunctionName(),
      file: frame == null ? void 0 : frame.getFileName(),
      line_number: frame == null ? void 0 : frame.getLineNumber(),
      hostname: Hostname.get()
    };
  }
  prepareMeta(meta) {
    return Object.assign(
      {},
      {
        node_ray_package_version: PACKAGE_VERSION != null ? PACKAGE_VERSION : "unknown",
        project_name: _Ray.projectName
      },
      meta
    );
  }
  executePayloadCallback(callbackType, args = []) {
    if (this.inCallback)
      return;
    this.inCallback = true;
    try {
      if (callbackType === SendRequestCallbackType.Sending && this.settings.sending_payload_callback !== null) {
        this.settings.sending_payload_callback(new _Ray(this.settings, this.client(), this.uuid, true), args);
      }
      if (callbackType === SendRequestCallbackType.Sent && this.settings.sent_payload_callback !== null) {
        this.settings.sent_payload_callback(this);
      }
    } catch (e) {
    }
    this.inCallback = false;
  }
  sendRequest(payloads, meta = []) {
    if (!this.enabled()) {
      return this;
    }
    if (!this.canSendPayload) {
      return this;
    }
    if (this.chaining) {
      const tempPayloads = Array.isArray(payloads) ? payloads : [payloads];
      this.chainedPayloads.push(...tempPayloads);
      return this;
    }
    if (this.limitOrigin !== null) {
      if (!_Ray.limiters.canSendPayload(this.limitOrigin)) {
        return this;
      }
      _Ray.limiters.increment(this.limitOrigin);
    }
    if (!Array.isArray(payloads)) {
      payloads = [payloads];
    }
    if (this.rateLimiter().isMaxReached() || this.rateLimiter().isMaxPerSecondReached()) {
      this.rateLimiter().notified = true;
      this.notifyWhenRateLimitReached();
      return this;
    }
    payloads.forEach((payload) => {
      this.getOriginData().then((data) => {
        payload.data.origin = data;
      });
      payload.remotePath = this.settings.remote_path;
      payload.localPath = this.settings.local_path;
    });
    this.executePayloadCallback(SendRequestCallbackType.Sending, payloads);
    _Ray.client.send(new Request(this.uuid, payloads, this.prepareMeta(meta)));
    this.rateLimiter().hit();
    this.executePayloadCallback(SendRequestCallbackType.Sent, payloads);
    return this;
  }
  rateLimiter() {
    return _Ray._rateLimiter;
  }
  async notifyWhenRateLimitReached() {
    if (this.rateLimiter().isNotified()) {
      return;
    }
    const customPayload = new CustomPayload("Rate limit has been reached...", "Rate limit");
    const request = new Request(this.uuid, [customPayload], []);
    await _Ray.client.send(request);
    this.rateLimiter().notify();
  }
  standalone(windowObject) {
    if (typeof windowObject !== "undefined") {
      windowObject.ray = ray;
      windowObject.Ray = _Ray;
    }
  }
};
__publicField(_Ray, "lockCounter", 0);
__publicField(_Ray, "defaultSettings", { not_defined: true });
__publicField(_Ray, "client");
__publicField(_Ray, "projectName", "");
__publicField(_Ray, "counters", new Counters());
__publicField(_Ray, "limiters", new Limiters());
__publicField(_Ray, "interceptor", new ConsoleInterceptor());
__publicField(_Ray, "fakeUuid");
__publicField(_Ray, "stopWatches", {});
__publicField(_Ray, "enabled", null);
__publicField(_Ray, "macros", {});
__publicField(_Ray, "_rateLimiter", RateLimiter.disabled());
let Ray = _Ray;
const ray = (...args) => {
  return Ray.create().send(...args);
};
const standalone = (windowObject) => {
  if (typeof windowObject !== "undefined") {
    windowObject.ray = ray;
    windowObject.Ray = Ray;
  }
};
if (false) {
  try {
    const win = window;
    win.ray = ray;
    win.Ray = Ray;
    win.rayInit = () => standalone(win);
  } catch (e) {
  }
}
export {
  Ray,
  ray,
  standalone
};
//# sourceMappingURL=web.js.map
